import { Skeleton } from "../skeleton";

export const InputSwitchSkeleton = () => {
	return <Skeleton height="1.5rem" width="3.1rem" borderRadius="0.75rem" />;
};
